import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from './Util/Session/session.service';
import { environment } from '../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserMasterService {

  constructor(
    private http: HttpClient,
    private session: SessionService
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  InsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_UserMaster/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  GetData(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_UserMaster_Select/get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  UpdateUserApplicability(Detail: any) {
    return this.http.post<any>(environment.API_URL + `WebESSUserAccessControlMasterDetail_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  LoadApplicability(Detail: any) {
    return this.http.post<any>(environment.API_URL + `WebESSUserAccessControlMasterDetail/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  GetOnlineUserRights(Detail: any) {
    return this.http.post<any>(environment.API_URL + `GetUserSitesDetails/OAS`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  UpdateOnlineUserRights(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_UserSiteRights_OAS/Insert`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  ComboLoad(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_FillCombo_User/Applicability`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}